<template>
  <div class="detail">
    <img class="img" :src="hospitalInfo.imgUuid" alt="">
    <h2 class="name">{{hospitalInfo.name}} <span>{{hospitalInfo.level}}</span></h2>
    <p class="location"><img src="../../../../assets/images/home/adress.png" alt=""> <span>{{hospitalInfo.city}}</span></p>
    <p class="con" v-html="hospitalInfo.introduction"></p>
    <p class="tel" v-html="hospitalInfo.baseInfo"></p>
    <!--<p class="tel">电话：<span>18611111111</span>  <span>024-98798798</span></p>-->
    <!--<p class="url">www.baidu.com</p>-->
    <!--<p class="address">地址：深圳市南山区科技园</p>-->
    <!--<p class="nature">医院性质：公里医院</p>-->
    <!--<p class="info">中国人民解放军总医院（301医院）创建于1953年，是集医疗、保健、教学、科研于一体的大型现代化综合性医院。图文）</p>-->
  </div>
</template>

<script>
import {reqHospitalInfo} from '../../../../api'
export default {
  data() {
    return {
      hospitalInfo:{}
    }
  },
  created() {
    const {hospitalId} = this.$route.query
    reqHospitalInfo(hospitalId).then(res => {
      if(res.code === 200){
        this.hospitalInfo = res.data.bussData
      }
    })
  }
}
</script>

<style scoped lang="less" type="text/less">
  .detail{
    float: left;
    width: 1020px;
    margin-bottom: 46px;
    .img{
      display: block;
      width: 100%;
      height: 300px;
      background: #ccc;
    }
    .name{
      margin-top:20px;
      font-size: 18px;
      font-weight: bold;
      span{
        font-weight: bold;
        color:#2FA1DE;
        margin-left: 13px;
      }
    }
    .location{
      margin-top:25px;
      img{
        vertical-align: middle;
      }
    }
    .con{
      margin-top:20px;
      line-height: 24px;
      font-family:PingFang-SC-Regular;
    }
    .tel{
      margin-top:59px;
    }
    .url, .address, .nature, .info{
      margin-top:20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Courier/Children/Hospital/Detail.vue